// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__36kZW","container":"styles_container__2V6ip","title":"styles_title__ZdWRr","wrapper":"styles_wrapper__1OSCn","answer":"styles_answer__lA0xg"};